import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNoticeIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17 5.5V5H16.5H1.5H1V5.5V14.75C1 15.9926 2.00736 17 3.25 17H14.75C15.9926 17 17 15.9926 17 14.75V5.5ZM1 4V4.5H1.5H16.5H17V4V3.25C17 2.00736 15.9926 1 14.75 1H3.25C2.00736 1 1 2.00736 1 3.25V4ZM14.75 0.5C16.2688 0.5 17.5 1.73122 17.5 3.25V14.75C17.5 16.2688 16.2688 17.5 14.75 17.5H3.25C1.73122 17.5 0.5 16.2688 0.5 14.75V3.25C0.5 1.73121 1.73121 0.5 3.25 0.5H14.75ZM4.75 12C5.16423 12 5.5 12.3358 5.5 12.75C5.5 13.1642 5.16423 13.5 4.75 13.5C4.33577 13.5 4 13.1642 4 12.75C4 12.3358 4.33577 12 4.75 12ZM9 12C9.41426 12 9.75 12.3357 9.75 12.75C9.75 13.1643 9.41426 13.5 9 13.5C8.58574 13.5 8.25 13.1643 8.25 12.75C8.25 12.3357 8.58574 12 9 12ZM4.75 8C5.16423 8 5.5 8.33575 5.5 8.75C5.5 9.16425 5.16423 9.5 4.75 9.5C4.33577 9.5 4 9.16425 4 8.75C4 8.33575 4.33577 8 4.75 8ZM9 8C9.41426 8 9.75 8.33574 9.75 8.75C9.75 9.16426 9.41426 9.5 9 9.5C8.58574 9.5 8.25 9.16426 8.25 8.75C8.25 8.33574 8.58574 8 9 8ZM13.25 8C13.6643 8 14 8.33574 14 8.75C14 9.16426 13.6643 9.5 13.25 9.5C12.8357 9.5 12.5 9.16426 12.5 8.75C12.5 8.33574 12.8357 8 13.25 8Z",
		fill: "currentColor",
		stroke: "currentColor"
	})
});
export default SvgNoticeIcon;
